import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const FeaturedCollection = ({ collection, onViewCollection }) => {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-conversion-accent/5 border border-primary/20 rounded-lg p-6 premium-hover">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="Star" size={16} className="text-primary" />
          <span className="text-sm font-semibold text-primary">Featured Collection</span>
        </div>
        <div className="flex items-center space-x-1 text-success">
          <Icon name="TrendingUp" size={14} />
          <span className="text-xs font-medium">+{collection?.performanceGrowth}%</span>
        </div>
      </div>
      <div className="flex items-start space-x-4">
        <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
          <Image
            src={collection?.coverImage}
            alt={collection?.name}
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="flex-1 min-w-0">
          <h4 className="text-lg font-semibold text-card-foreground mb-1">
            {collection?.name}
          </h4>
          <p className="text-sm text-muted-foreground mb-2">
            by {collection?.collector?.name}
          </p>
          <p className="text-xs text-muted-foreground line-clamp-2 mb-3">
            {collection?.description}
          </p>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="text-center">
                <p className="text-lg font-bold text-card-foreground">{collection?.itemCount}</p>
                <p className="text-xs text-muted-foreground">Items</p>
              </div>
              <div className="text-center">
                <p className="text-lg font-bold text-success">${collection?.totalValue?.toLocaleString()}</p>
                <p className="text-xs text-muted-foreground">Value</p>
              </div>
            </div>
            
            <Button 
              variant="outline" 
              size="sm"
              onClick={() => onViewCollection(collection)}
            >
              View Collection
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedCollection;